import { render, staticRenderFns } from "./BotChatList.vue?vue&type=template&id=971cc70e&scoped=true&"
import script from "./BotChatList.vue?vue&type=script&lang=js&"
export * from "./BotChatList.vue?vue&type=script&lang=js&"
import style0 from "./BotChatList.vue?vue&type=style&index=0&id=971cc70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cc70e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('971cc70e')) {
      api.createRecord('971cc70e', component.options)
    } else {
      api.reload('971cc70e', component.options)
    }
    module.hot.accept("./BotChatList.vue?vue&type=template&id=971cc70e&scoped=true&", function () {
      api.rerender('971cc70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ChatBot/BotChatList.vue"
export default component.exports